export default "__VITE_ASSET__sMUN20EO__"